module.exports = __webpack_public_path__ + "img/correct.af0b1bb2.png";